import {
  Checkbox,
  FormControlLabel,
  withStyles,
  Grid,
} from "@material-ui/core";
import styles from "./styles";
import { PICKUP_OPTIMYZER_FILTER_NAME } from "../constants";

const PickupCheckbox = ({
  classes,
  isPartialAssignedPickupsSelected,
  isPartialUnassignedPickupsSelected,
  isAssigned,
  handleFilterChange,
  isUnassigned,
}) => {
  return (
    <Grid container className={classes.infoContainer}>
      <div className={classes.headerLabel}>Select Pickups</div>
      <Grid item md={12} xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={isAssigned}
              classes={{
                root: classes.checkBoxStyle,
              }}
              onChange={handleFilterChange}
              name={PICKUP_OPTIMYZER_FILTER_NAME.isAssigned}
              color={isPartialAssignedPickupsSelected ? "default" : "primary"}
              indeterminate={isPartialAssignedPickupsSelected}
            />
          }
          classes={{ label: classes.checkBoxLabel }}
          label={
            <span>
              <p className={classes.checkBoxLabelBold}>Assigned pickups</p>
              <p className={classes.checkBoxLabel}>
                (Re-evaluates existing assignments based on current driver
                situations)
              </p>
            </span>
          }
        />
      </Grid>
      <Grid item md={12} xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={isUnassigned}
              classes={{
                root: classes.checkBoxStyle,
              }}
              onChange={handleFilterChange}
              name={PICKUP_OPTIMYZER_FILTER_NAME.isUnassigned}
              color={isPartialUnassignedPickupsSelected ? "default" : "primary"}
              indeterminate={isPartialUnassignedPickupsSelected}
            />
          }
          classes={{ label: classes.checkBoxLabel }}
          label={
            <span>
              <p className={classes.checkBoxLabelBold}>Unassigned pickups</p>
              <p className={classes.checkBoxLabel}>
                (Optimally suggests new pickups)
              </p>
            </span>
          }
        />
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(PickupCheckbox);
